import { useState } from "react";
import { ServiceTypes } from "src/api/adminMemo/adminmemo-types";
import { useApiOperation } from "src/api/hooks";
import { Modal, UnionCmdType } from "src/api/public-types";
import { submitVocItemAsync } from "src/api/voc/voc-api";
import { CsItemModel, VocModelUpdate } from "src/api/voc/voc-types";
import { BaseButton, BaseConfirmModal, BaseModal } from "src/components";
import AdminMemoV3 from "src/components/AdminMemoV3/AdminMemoV3";
import GoToListButton from "src/components/GoToListButton";
import Link from "src/components/PartnerLink";
import RegistrationInformation from "src/components/RegistrationInformation";
import { ArticleSection } from "src/components/layout/ArticleSection";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import useNavigate from "src/hooks/usePartnerNavigate";
import { PagePath } from "src/pages/product/details";

type Props = {
  vocDetail: CsItemModel | undefined;
  buildings: { id: string; buildingName: string }[];
};

const BasicInfoDetail = ({ vocDetail, buildings }: Props) => {
  const navigate = useNavigate();

  const [confirmModal, setConfirmModal] = useState<Modal>({ isOpen: false });

  const [alertModal, setAlertModal] = useState<Modal>({ isOpen: false });

  const { isAuthority } = usePartnerAuthority();

  // 등록/수정
  const { executeAsync: submitVocItem } = useApiOperation(submitVocItemAsync);

  const handleSubmitVocItems = async (vocData: VocModelUpdate) => {
    await submitVocItem(vocData);
    navigate(PagePath.voc.list);
  };

  return (
    <div>
      {true && (
        <div className="contents-container__scroll">
          <div className="contents-container__wrap ">
            <ArticleSection title="VoC 정보">
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>유형</p>
                </div>
                <div className="contents-container__grid-contents">
                  <div className="minmax400">
                    <span>{vocDetail?.csTypeName || "-"}</span>
                  </div>
                </div>
              </section>
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>항목</p>
                </div>
                <div className="contents-container__grid-contents">
                  <div className="minmax400">
                    <span>{vocDetail?.csItemName || "-"}</span>
                  </div>
                </div>
              </section>
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>적용된 건물</p>
                </div>
                <div className="contents-container__grid-contents flex-center ">
                  <div className="flex-row flex-center-start flex-wrap ">
                    {buildings.length > 0 ? (
                      buildings.map((building, index) => (
                        <div className="mr15 h-36 flex-center " key={building.id}>
                          <span>{`${building.buildingName} (건물 ID:`} </span>
                          <Link className="text-underline" target="_blank" to={PagePath.building.detail.replaceAll(":id", building.id)}>
                            {building.id}
                          </Link>
                          <span className="ic-target-blank"></span>
                          <span>{`)${index < buildings.length - 1 ? "," : ""}`}</span>
                        </div>
                      ))
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                </div>
              </section>
            </ArticleSection>

            <RegistrationInformation data={vocDetail} />

            {vocDetail && <AdminMemoV3 serviceId={Number(vocDetail.id)} serviceType={ServiceTypes.SERVICE_CS_ITEM} />}
          </div>
        </div>
      )}

      {/* 버튼영역 */}
      <div className="contents-container__btn-wrap">
        <div className="left-area">
          <GoToListButton />
        </div>

        <div className="right-area">
          {isAuthority("d") && (
            <BaseButton
              title="삭제"
              className=" color-white size-large mr5"
              onClick={() => {
                if (buildings.length > 0) {
                  setAlertModal({ isOpen: true, message: "VoC항목이 적용된 건물이 있어 삭제할 수 없습니다." });
                } else {
                  setConfirmModal({
                    isOpen: true,
                    message: "삭제하시겠습니까?",
                    type: "BUILDING_DELETE",
                  });
                }
              }}
            />
          )}
          {isAuthority("w") && (
            <BaseButton
              title="수정"
              className="size-large"
              onClick={() => {
                const formPath = `${PagePath.voc.form}?id=${vocDetail?.id}`;
                navigate(formPath);
              }}
            />
          )}
        </div>
      </div>
      <>
        {confirmModal.isOpen && (
          <BaseModal
            isOpen={true}
            btnLeftTitle="취소"
            btnRightTitle="확인"
            title={confirmModal.message}
            onClick={() => {
              const data = { ...vocDetail, cmdType: "D" as UnionCmdType };
              handleSubmitVocItems(data);
            }}
            onClose={() => setConfirmModal({ isOpen: false })}
          ></BaseModal>
        )}

        {alertModal.isOpen && (
          <BaseConfirmModal
            isOpen={true}
            btnRightTitle="확인"
            title={alertModal.message}
            onClick={() => setAlertModal({ isOpen: false })}
          ></BaseConfirmModal>
        )}
      </>
    </div>
  );
};

export default BasicInfoDetail;
